import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Receipt } from '../types/receipt';
import { EnvService } from '../services/env.service';

 
const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class ReceiptService {

  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/receipts/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

   getAll():Observable <Receipt[]> {
    return this.http.get <Receipt[]>(`${this.env.apiUrl}/receipts`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getReceipt(receiptNo):Observable <Receipt> {
      return this.http.get<Receipt>(`${this.env.apiUrl}/receipts/${receiptNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }



    addReceipt(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/receipts`, data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteReceipt(data,receiptNo):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/receipts/${receiptNo}`, data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       



}
